import { Routes } from "@angular/router"
import { HomeComponent } from "./components/home/home.component"
import { LoginComponent } from "./components/login/login.component"
import { SignupComponent } from "./components/signup/signup.component"
import { UserHomeComponent } from "./components/user-home/user-home.component"
import { ManageCampaignsComponent } from "./components/manage-campaigns/manage-campaigns.component"
import { CampaignBuilderComponent } from "./components/campaign-builder/campaign-builder.component"
import { CampaignPreviewComponent } from "./components/campaign-preview/campaign-preview.component" // Added import for CampaignPreviewComponent
import { ProfileComponent } from "./components/profile/profile.component"
import { UserSettingsComponent } from "./components/user-settings/user-settings.component"
import { UploadRatingsComponent } from "./components/upload-ratings/upload-ratings.component"
import { ManageOwnersComponent } from "./components/manage-owners/manage-owners.component"
import { StaffDirectoryComponent } from "./components/staff-directory/staff-directory.component"
import { UserAnalyticsComponent } from "./components/user-analytics/user-analytics.component"
import { ManageStationClocksComponent } from "./components/manage-station-clocks/manage-station-clocks.component"
import { ManageRatingsComponent } from "./components/manage-ratings/manage-ratings.component"
import { ManageStationsComponent } from "./components/manage-stations/manage-stations.component"
import { OtpVerificationComponent } from "./components/otp-verification/otp-verification.component"
import { ResetPasswordComponent } from "./components/reset-password/reset-password.component"
import { SetPasswordComponent } from "./components/set-password/set-password.component"
import { UnauthorizedComponent } from "./components/unauthorized/unauthorized.component"
import { PaymentSuccessComponent } from "./components/payment-success/payment-success.component"
import { PaymentFailureComponent } from "./components/payment-failure/payment-failure.component"
import { AuthGuard } from "./guards/auth.guard"
import { RoleGuard } from "./guards/role.guard"
import { ManageStationRatesComponent } from "./components/manage-station-rates/manage-station-rates.component"
import { RecordingsListComponent } from "./components/recordings-list/recordings-list.component"
import { AudioUploadRecordingComponent } from "./components/audio-upload-recording/audio-upload-recording.component"
import { ProductionRequestListComponent } from "./components/production-request/production-request-list.component"
import { ProductionRequestCreateComponent } from "./components/production-request/production-request-create.component"
import { ProductionRequestDetailComponent } from "./components/production-request/production-request-detail.component"
import { CreateCommercialComponent } from "./components/production-request/create-commercial.component"
import { HelpComponent } from "./components/help/help.component"
import { TicketInboxComponent } from "./components/help/ticket-inbox/ticket-inbox.component"
import { TicketDetailComponent } from "./components/help/ticket-detail/ticket-detail.component"
import { SupportAnalyticsComponent } from "./components/help/support-analytics/support-analytics.component"
import { SupportSettingsComponent } from "./components/help/support-settings/support-settings.component"
// Lazy import Orders page component

export const routes: Routes = [
  { path: "home", component: HomeComponent },
  { path: "login", component: LoginComponent },
  { path: "signup", component: SignupComponent },
  { path: "verify-otp", component: OtpVerificationComponent },
  { path: "reset-password", component: ResetPasswordComponent },
  { path: "set-password", component: SetPasswordComponent },
  { path: "unauthorized", component: UnauthorizedComponent },

  {
    path: "orders",
    loadComponent: () => import("./components/orders/orders.component").then(m => m.OrdersComponent),
    canActivate: [AuthGuard],
  },
  {
    path: "cart",
    loadComponent: () => import("./components/cart/cart.component").then(m => m.CartComponent),
    canActivate: [AuthGuard],
  },
  {
    path: "profile",
    component: ProfileComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "settings",
    component: UserSettingsComponent,
    canActivate: [AuthGuard, RoleGuard],
    data: {
      roles: ["admin", "owner", "station_owner", "station_user", "user"],
    },
  },
  {
    path: "userhome",
    component: UserHomeComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "uploadratings",
    component: UploadRatingsComponent,
    canActivate: [AuthGuard, RoleGuard],
    data: {
      roles: ["admin", "owner", "station_owner"],
    },
  },
  {
    path: "managecampaigns",
    component: ManageCampaignsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "campaignbuilder",
    component: CampaignBuilderComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "campaign-preview",
    component: CampaignPreviewComponent,
    canActivate: [AuthGuard],
  }, // Added route for campaign preview page
  {
    path: "payment/:orderId",
    loadComponent: () => import("./components/payment-page/payment-page.component").then(m => m.PaymentPageComponent),
    canActivate: [AuthGuard],
  },
  {
    path: "payment-return",
    loadComponent: () => import("./components/payment-return/payment-return.component").then(m => m.PaymentReturnComponent),
    canActivate: [AuthGuard],
  },
  {
    path: "payment-success",
    component: PaymentSuccessComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "payment-failure",
    component: PaymentFailureComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "manageowners",
    component: ManageOwnersComponent,
    canActivate: [AuthGuard, RoleGuard],
    data: {
      roles: ["admin"],
    },
  },
  {
    path: "staff-directory",
    component: StaffDirectoryComponent,
    canActivate: [AuthGuard, RoleGuard],
    data: {
      roles: ["admin"],
    },
  },
  {
    path: "user-analytics",
    component: UserAnalyticsComponent,
    canActivate: [AuthGuard, RoleGuard],
    data: {
      roles: ["admin"],
    },
  },
  {
    path: "managestationclocks",
    component: ManageStationClocksComponent,
    canActivate: [AuthGuard, RoleGuard],
    data: {
      roles: ["admin", "owner", "station_owner", "station_user"],
    },
  },
  {
    path: "manageratings",
    component: ManageRatingsComponent,
    canActivate: [AuthGuard, RoleGuard],
    data: {
      roles: ["admin", "owner", "station_owner", "station_user"],
    },
  },
  {
    path: "managestationrates",
    component: ManageStationRatesComponent,
    canActivate: [AuthGuard, RoleGuard],
    data: {
      roles: ["admin", "owner", "station_owner", "station_user"],
    },
  },
  {
    path: "managestations",
    component: ManageStationsComponent,
    canActivate: [AuthGuard, RoleGuard],
    data: {
      roles: ["admin", "owner", "station_owner", "station_user", "user"],
    },
  },
  {
    path: "managestations/add",
    loadComponent: () =>
      import("./components/manage-stations/add-station/add-station.component").then((m) => m.AddStationComponent),
    canActivate: [AuthGuard, RoleGuard],
    data: {
      roles: ["admin", "owner", "station_owner"],
    },
  },
  {
    path: "managestations/:id/edit",
    loadComponent: () =>
      import("./components/manage-stations/edit-station/edit-station.component").then((m) => m.EditStationComponent),
    canActivate: [AuthGuard, RoleGuard],
    data: {
      roles: ["admin", "owner", "station_owner"],
    },
  },
  {
    path: "recordings",
    component: RecordingsListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "audio",
    component: AudioUploadRecordingComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "production-requests",
    component: ProductionRequestListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "production-requests/create",
    component: ProductionRequestCreateComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "production-requests/:id/create-commercial",
    component: CreateCommercialComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "production-requests/:id",
    component: ProductionRequestDetailComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "promo-codes",
    loadComponent: () =>
      import("./components/promo-codes/promo-codes-list.component").then((m) => m.PromoCodesListComponent),
    canActivate: [AuthGuard, RoleGuard],
    data: { roles: ["admin", "owner"] },
  },
  {
    path: "promo-codes/create",
    loadComponent: () =>
      import("./components/promo-codes/promo-code-create.component").then((m) => m.PromoCodeCreateComponent),
    canActivate: [AuthGuard, RoleGuard],
    data: { roles: ["admin", "owner"] },
  },
  {
    path: "promo-codes/:id/edit",
    loadComponent: () =>
      import("./components/promo-codes/promo-code-create.component").then((m) => m.PromoCodeCreateComponent),
    canActivate: [AuthGuard, RoleGuard],
    data: { roles: ["admin", "owner"] },
  },
  {
    path: "promo-codes/:id",
    loadComponent: () =>
      import("./components/promo-codes/promo-code-detail.component").then((m) => m.PromoCodeDetailComponent),
    canActivate: [AuthGuard, RoleGuard],
    data: { roles: ["admin", "owner"] },
  },
  {
    path: "my-offers",
    loadComponent: () => import("./components/my-offers/my-offers.component").then((m) => m.MyOffersComponent),
    canActivate: [AuthGuard, RoleGuard],
    data: { roles: ["user"], advertiserOnly: true },
  },
  {
    path: "billing",
    loadComponent: () => import("./components/billing/billing.component").then((m) => m.BillingComponent),
    canActivate: [AuthGuard, RoleGuard],
    // Owner of at least one station (or admin); the backend scopes each station to its owner.
    data: { roles: ["admin", "owner"] },
  },
  {
    path: "help",
    component: HelpComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "help/tickets",
    component: TicketInboxComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "help/analytics",
    component: SupportAnalyticsComponent,
    canActivate: [AuthGuard, RoleGuard],
    data: { roles: ["admin"] },
  },
  {
    path: "help/settings",
    component: SupportSettingsComponent,
    canActivate: [AuthGuard, RoleGuard],
    data: { roles: ["admin"] },
  },
  {
    path: "help/tickets/:id",
    component: TicketDetailComponent,
    canActivate: [AuthGuard],
  },
  { path: "", redirectTo: "/login", pathMatch: "full" },
]
